function HeroBanner({ onShopCollection }) {
  return (
    <section
      style={{
        marginBottom: "34px",
        background: "linear-gradient(140deg, #ffffff 0%, #f0fdf4 55%, #ecfdf5 100%)",
        borderRadius: "26px",
        boxShadow: "0 16px 40px rgba(15, 23, 42, 0.08)",
        border: "1px solid #d1fae5",
        padding: "28px",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "26px",
          alignItems: "center",
        }}
      >
        <div>
          <p
            style={{
              margin: "0 0 12px 0",
              color: "#166534",
              fontWeight: "700",
              fontSize: "13px",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}
          >
            Natural Care for Everyday Beauty
          </p>

          <h1
            style={{
              margin: "0 0 14px 0",
              color: "#0f172a",
              fontSize: "42px",
              lineHeight: "1.12",
              maxWidth: "560px",
              fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif',
            }}
          >
            Discover the Pure Touch of Manna
          </h1>

          <p
            style={{
              margin: "0 0 24px 0",
              color: "#334155",
              fontSize: "16px",
              lineHeight: "1.65",
              maxWidth: "540px",
            }}
          >
            Explore aloe vera based skincare and personal care products made to refresh, nourish, and glow.
          </p>

          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            <button
              onClick={onShopCollection}
              style={{
                background: "linear-gradient(135deg, #16a34a, #15803d)",
                border: "none",
                color: "white",
                padding: "12px 20px",
                borderRadius: "999px",
                fontWeight: "700",
                cursor: "pointer",
                boxShadow: "0 8px 18px rgba(22, 163, 74, 0.25)",
              }}
            >
              Shop Collection
            </button>

            <button
              type="button"
              style={{
                background: "#ffffff",
                border: "1px solid #bbf7d0",
                color: "#14532d",
                padding: "12px 20px",
                borderRadius: "999px",
                fontWeight: "700",
                cursor: "default",
              }}
            >
              Coming Soon
            </button>
          </div>
        </div>

        <div
          style={{
            minHeight: "250px",
            borderRadius: "24px",
            background: "linear-gradient(160deg, #dcfce7 0%, #bbf7d0 45%, #f0fdf4 100%)",
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-36px",
              right: "-28px",
              width: "150px",
              height: "150px",
              borderRadius: "999px",
              background: "rgba(255,255,255,0.45)",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "-55px",
              left: "-20px",
              width: "190px",
              height: "190px",
              borderRadius: "26px",
              transform: "rotate(-10deg)",
              background: "rgba(255,255,255,0.35)",
            }}
          />

          <div
            style={{
              position: "relative",
              background: "rgba(255,255,255,0.72)",
              border: "1px solid rgba(255,255,255,0.7)",
              borderRadius: "18px",
              padding: "18px",
              boxShadow: "0 10px 26px rgba(15, 23, 42, 0.08)",
            }}
          >
            <p
              style={{
                margin: "0 0 8px 0",
                color: "#14532d",
                fontWeight: "700",
                fontSize: "13px",
                letterSpacing: "0.06em",
                textTransform: "uppercase",
              }}
            >
              Manna Signature
            </p>
            <p
              style={{
                margin: 0,
                color: "#0f172a",
                fontSize: "18px",
                lineHeight: "1.4",
                fontWeight: "700",
              }}
            >
              Aloe Vera • Skincare • Natural Glow
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroBanner;
